import React, { useRef, useState } from "react";
import "./css/RowExpansionTemplate.css";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import moment from "moment";
import { PlanEditIcon } from "../../../../../../../../../../utility";
import { OverlayPanel } from "primereact/overlaypanel";

export const RowExpansionTemplate = ({
  setIsVoidDialogActive,
  PaymentLogExpansionRowData,
  setRowData,
  setIsRefundDialogActive,
  cpData,
}) => {
  const op = useRef(null);
  const OverlayRef = useRef(null);
  const [overlayContent, setOverlayContent] = useState("");

  return (
    <div className="row-expansion-container">
      <DataTable
        showHeaders={false}
        value={PaymentLogExpansionRowData[0].remaining}
      >
        <Column
          field="invoiceNo"
          header="Invoice No"
          body={(rowData) => (
            <div className="expander-row-invoiceno">
              <i style={{ border: "none !important" }} />
              <p>{rowData?.invoiceNo}</p>
            </div>
          )}
        />

        <Column
          header="Created Date"
          body={(rowData) => {
            return (
              <span>
                {moment(rowData.date)
                  .tz("America/New_York") // Convert to New York time (Eastern Time Zone)
                  .format("MM-DD-YYYY")}
              </span>
            );
          }}
        />
        <Column
          field="invoiceType"
          header="Type"
          body={(rowData) => (
            <>
              <p
                onMouseEnter={(e) => {
                  if (rowData?.invoiceType[0].length > 15) {
                    setOverlayContent(rowData?.invoiceType[0]);
                    OverlayRef.current.show(e);
                  }
                }}
                onMouseLeave={() => OverlayRef.current.hide()}
              >
                {rowData?.invoiceType[0].length > 15
                  ? rowData?.invoiceType[0]?.substring(0, 12) + "..."
                  : rowData.invoiceType[0]}
              </p>
              <OverlayPanel ref={OverlayRef}>
                <div style={{ padding: "0.5rem 1rem" }}>
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: "1.4rem",
                      overflow: "hidden",
                      border: "none",
                      margin: "0rem",
                      lineHeight: "1.8rem",
                      color: "#72728f",
                    }}
                  >
                    {" "}
                    {overlayContent}
                  </p>
                </div>
              </OverlayPanel>
            </>
          )}
        />

        <Column
          field="paymentStatus"
          body={(rowData) => (
            <p
              className={`${rowData.paymentStatus === "failure" ? "status-failure" : "status-success"}`}
            >
              {rowData.transactionStatus.charAt(0).toUpperCase() +
                rowData.transactionStatus.slice(1)}
            </p>
          )}
          header="Status"
        />
        <Column
          field="cardDetails.cardNumber"
          header="Card Details"
          body={(rowData) => {
            return (
              <>
                <p
                  onMouseEnter={(e) => {
                    if (rowData?.cardDetails?.cardNumber?.length > 4) {
                      setOverlayContent(rowData?.cardDetails?.cardNumber);
                      OverlayRef.current.show(e);
                    }
                  }}
                  onMouseLeave={() => OverlayRef.current.hide()}
                >
                  {rowData?.cardDetails?.cardNumber
                    ? rowData?.cardDetails?.cardNumber?.length > 4
                      ? rowData?.cardDetails?.cardNumber?.substring(0, 4) +
                        "..."
                      : rowData?.cardDetails?.cardNumber
                    : "NIL"}
                </p>
                <OverlayPanel ref={OverlayRef}>
                  <div style={{ padding: "0.5rem 1rem" }}>
                    <p
                      style={{
                        fontWeight: 400,
                        fontSize: "1.4rem",
                        overflow: "hidden",
                        border: "none",
                        margin: "0rem",
                        lineHeight: "1.8rem",
                        color: "#72728f",
                      }}
                    >
                      {" "}
                      {overlayContent}
                    </p>
                  </div>
                </OverlayPanel>
              </>
            );
          }}
        />

        <Column
          field="amount"
          header="Amount"
          body={(rowData) =>
            rowData?.amount !== undefined &&
            rowData?.amount !== "NaN" &&
            rowData?.amount !== ""
              ? parseFloat(rowData?.amount).toFixed(2)
              : "0.00"
          }
        />
        <Column
          field="currentBalance"
          header="Current Bill"
          body={(rowData) =>
            rowData?.currentBalance !== undefined &&
            rowData?.currentBalance !== "NaN" &&
            rowData?.currentBalance !== ""
              ? parseFloat(rowData?.currentBalance).toFixed(2)
              : "0.00"
          }
        />
        <Column
          field="previousBalance"
          body={(rowData) =>
            rowData?.previousBalance !== undefined &&
            rowData?.previousBalance !== "NaN" &&
            rowData?.previousBalance !== ""
              ? parseFloat(rowData?.previousBalance).toFixed(2)
              : "0.00"
          }
          header="Previous Balance"
        />

        <Column
          field="transactionId"
          header="Transaction ID"
          body={(rowData) => {
            return (
              <>
                <p
                  onMouseEnter={(e) => {
                    if (rowData?.transactionId?.length > 23) {
                      setOverlayContent(rowData?.transactionId);
                      OverlayRef.current.show(e);
                    }
                  }}
                  onMouseLeave={() => OverlayRef.current.hide()}
                >
                  {rowData?.transactionId
                    ? rowData?.transactionId?.length > 23
                      ? rowData?.transactionId?.substring(0, 22) + "..."
                      : rowData?.transactionId
                    : "NIL"}
                </p>
                <OverlayPanel ref={OverlayRef}>
                  <div style={{ padding: "0.5rem 1rem" }}>
                    <p
                      style={{
                        fontWeight: 400,
                        fontSize: "1.4rem",
                        overflow: "hidden",
                        border: "none",
                        margin: "0rem",
                        lineHeight: "1.8rem",
                        color: "#72728f",
                      }}
                    >
                      {overlayContent}
                    </p>
                  </div>
                </OverlayPanel>
              </>
            );
          }}
        />
        <Column
          field="Actions"
          header="Actions"
          body={(rowData) => {
            return (
              <div className="flex flex-wrap flex-row justify-content-end  w-full h-full align-items-center main-action-wrapper actionbtnmain">
                <div
                  className="flex flex-wrap flex-row justify-content-end  w-full h-full align-items-center main-action-wrapper actionbtnmain"
                  onClick={(e) => {
                    op.current.toggle(e);
                    setRowData(rowData);
                  }}
                >
                  <PlanEditIcon />
                </div>
                <OverlayPanel
                  ref={op}
                  style={{ width: "10.9rem", height: "8rem" }}
                  className="flex align-items-center billingconfig"
                >
                  <div className="flex flex-column w-full overlay">
                    <div
                      className="flex justify-content-start align-items-center prospectoverlay"
                      style={{
                        height: "3.2rem",
                        width: "10.7rem",
                        paddingLeft: "1.2rem",
                      }}
                      onClick={() => {
                        setRowData(rowData);
                        setIsVoidDialogActive(true);
                      }}
                    >
                      <label style={{ fontSize: "1.2rem", fontWeight: "500" }}>
                        Void
                      </label>
                    </div>
                    <div
                      className="flex justify-content-start align-items-center prospectoverlay"
                      style={{
                        height: "3.2rem",
                        width: "10.7rem",
                        paddingLeft: "1.2rem",
                      }}
                      onClick={() => {
                        setRowData(rowData);
                        setIsRefundDialogActive(true);
                      }}
                    >
                      <label style={{ fontSize: "1.2rem", fontWeight: "500" }}>
                        Refund
                      </label>
                    </div>
                  </div>
                </OverlayPanel>
              </div>
            );
          }}
        />
      </DataTable>
    </div>
  );
};
